import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunityOwnProfile, CommunityProfileUpdate, CommunityPractitionerEntry } from '../models/community-profile.models';

/**
 * The member's own community profile (`/api/community/profile`, Phase 3):
 * bio, calling, contact fields with per-field visibility, the practitioner
 * switches and the avatar.
 */
@Injectable({ providedIn: 'root' })
export class CommunityProfileService {
  private readonly base = '/community/profile';

  /** Mirrors the backend's AVATAR_MAX_BYTES / AVATAR_EXTENSIONS, checked before uploading. */
  static readonly AVATAR_MAX_BYTES = 5 * 1024 * 1024;
  static readonly AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

  constructor(private http: HttpClient) {}

  /** The practitioner directory (Find a Professional): visible practitioners only. */
  listPractitioners(params: { q?: string; country?: string } = {}): Observable<{ data: CommunityPractitionerEntry[] }> {
    const clean: Record<string, string> = {};
    if (params.q) clean['q'] = params.q;
    if (params.country) clean['country'] = params.country;
    return this.http.get<{ data: CommunityPractitionerEntry[] }>('/community/practitioners', { params: clean });
  }

  getProfile(): Observable<{ profile: CommunityOwnProfile }> {
    return this.http.get<{ profile: CommunityOwnProfile }>(this.base);
  }

  /** Partial update: only the keys sent change. */
  updateProfile(profile: CommunityProfileUpdate): Observable<{ profile: CommunityOwnProfile }> {
    return this.http.put<{ profile: CommunityOwnProfile }>(this.base, { profile });
  }

  /** Multipart `file`; the browser sets the boundary, so no content type is forced here. */
  uploadAvatar(file: File): Observable<{ avatar_url: string }> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<{ avatar_url: string }>(`${this.base}/avatar`, form);
  }

  deleteAvatar(): Observable<{ avatar_url: null }> {
    return this.http.delete<{ avatar_url: null }>(`${this.base}/avatar`);
  }
}
